// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

M.Model = M.Model || {};

/**
 * @class M.Model.CyclerSlide
 */
M.Model.CyclerSlide = Backbone.Model.extend();
